import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { UpdateStatusQuizManagementSlice } from "../../../../redux/features/Quiz Management/QuizManagementByManual";

const ViewQuiz = () => {
  const { state} = useLocation();
  const [iState, setUpdate] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

   const [optionSet, setOptionSet] = useState({
    option1: "",
    option2: "",
    option3: "",
    option4: "",
  });

  useEffect(() => {
    console.log(state);
    setUpdate(state);
  }, [state]);

  const updateStatusQuiz = ({ id, status }) => {
    const data = {
      status: status,
      isActive: true,
    };

    dispatch(UpdateStatusQuizManagementSlice({ id, data }))?.then((res) => {
      if(res?.payload?.customStatus === 200){
        console.log(res);
        navigate("/QuizManagement/QuizUploadByAdmin/AllPublishedQuiz")
      }
      
    });
  };

  return (
    <>
      <div className="WrapperBox">
        <div className="TitleBox">
          <h4 className="Title">Quiz Management</h4>
          <span>
            <a className="TitleLink" onClick={() => navigate(-1)}>
              <i className="fa fa-arrow-left" />
              Back
            </a>
          </span>
        </div>
        <div className="Small-Wrapper">
          <div className="CommonForm">
            <h4>Add Quiz</h4>
            <div className="row">
              <div className="col-12" style={{ marginBottom: "20px" }}>
                <span
                  title="is this quiz in trending ?"
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    gap: "10px",
                    width: "fit-content",
                  }}
                  onClick={() =>{
                    if(iState?.status === "pending"){
                      setUpdate((prev) => ({
                        ...prev,
                        quizDetail: {
                          ...prev["quizDetail"],
                          isTrending: !iState?.quizDetail?.isTrending || false,
                        },
                      }))
                    } 
                  }
                  }
                >
                  <input
                    type="radio"
                    disabled={!iState?.quizDetail?.isTrending || false}
                    checked={iState?.quizDetail?.isTrending || false} 
                  />
                  <p>isTrending</p>
                </span>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Quiz Category</label>
                  <input
                    type="text"
                    disabled
                    value={iState?.quizDetail?.quizcategory}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Level</label>
                  <input
                    type="text"
                    disabled
                    value={iState?.quizDetail?.level}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Choose Number of Questions</label>
                  <input
                    type="text"
                    className="form-control"
                    value={iState?.questionDetail?.length || 0}
                    disabled
                  />
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Number of options for Answers</label>
                  <input
                    type="text"
                    disabled
                    value={iState?.quizDetail?.optionsforanswers}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Duration</label>
                  <input
                    type="text"
                    disabled
                    value={iState?.quizDetail?.duration + " min"}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Question Paper Name</label>
                  <input
                    type="text"
                    disabled
                    value={iState?.quizDetail?.papername}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="Small-Wrapper">
              {iState?.questionDetail?.map((item, index) => {
                const optionData = Object.entries(item);

                console.log(item) 

                return (
                  <>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <label>Question {index + 1}</label>
                          <input
                            type="text"
                            name="question"
                            className="form-control"
                            value={item?.question}
                            disabled
                            placeholder="The bacterium Arobacterium tumeficians is used to obtain which of the following ?"
                          />
                        </div>
                      </div>{" "}
                      {/* {optionData?.map(([key, value], i) => {
                        if (
                          ![
                            "hint",
                            "optionanswer",
                            "questionnumber",
                            "_id",
                          ]?.includes(key)
                        ) {
                          return (
                            <>
                              <div className="col-4">
                                <div className="form-group">
                                  <label>Option {i}</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Bt-toxin"
                                    value={value}
                                    disabled
                                  />
                                </div>
                              </div>
                            </>
                          );
                        }
                      })} */}
                        {Object.keys(optionSet)
                        ?.slice(0, iState?.quizDetail?.optionsforanswers)
                        ?.map((item, i) => {
                          return (
                            <div className="col-4">
                              {" "}
                              <div className="form-group">
                                <label>Option {i + 1}</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Bt-toxin"
                                  name={item}
                                  disabled
                                  value={iState["questionDetail"][index][item]}
                                  // onChange={(e) =>
                                  //   hanldeQuiz(e, "questionDetail", index)
                                  // }
                                />
                                {/* {errorCustom?.[index]?.[item]?.length > 0 && (
                                  <div className="text-danger">
                                    Please enter the question!
                                  </div>
                                )} */}
                              </div>
                            </div>
                          );
                        })}
                      <div className="col-4">
                        <div className="form-group">
                          <label>Choose options for Answers</label>
                          <input type="text" disabled value={item?.optionanswer} className="form-control"/>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label>Hint</label>
                          <input type="text" disabled value={item?.hint} className="form-control"/>

                        </div>
                      </div>
                    </div>
                    {index !== iState?.questionDetail?.length - 1 && (
                      <div
                        style={{
                          border: "1px solid black",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      ></div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
          {iState?.status==="pending" &&
      <button
        style={{
          backgroundColor: "#e3083f",
          color: "white",
          height: "40px",
          width: "90px",
          border: "none",
          borderRadius: "5px",
          marginTop: "10px",
        }}
        onClick={()=>updateStatusQuiz({id:iState?._id,status:"published"})}
      >
        Publish
      </button>
      }
        </div>
      </div>
    </>
  );
};

export default ViewQuiz;
